// @flow

import { type Node } from 'react';

export type QuestionType = {
  question: string,
  answer: Node,
  mediaUrl: string,
  key: string,
};

export const GUIDE_VIEW = 'guide';
export const WELCOME_VIEW = 'welcome';
export const TEAMS_MODAL_TRACKING_KEY = 'hasViewedWelcomeTeamsModal';
